import { baseURL } from "repository/Repository";
import { io } from "socket.io-client";

export let socket = io(baseURL, {
  autoConnect: false,
});
export function addUserSocket(userId, role) {
  console.log(userId, role, "addUserConnection");
  socket.auth = { userId, role };
  socket.connect();
  socket.emit("addUserSocket", userId, role);
}
export function sendMessageSocket(payload) {
  console.log("send message??>>>>>>", payload);
  socket.emit("sendMessage", payload);
}
export function pageRefresh(userId, role) {
  console.log("pageReferech");
  socket.auth = { userId, role };
  socket.connect();
  socket.emit("pageRefresh", userId, role);
}
export function getMessage() {
  console.log("in get message socket");
  socket.on("getMessage", function (msg) {
    console.log(msg);
  });
}
export function disconnectSocket() {
  socket.emit("disconnectSocket");
  socket.disconnect();
}

let adminStatusChannel = null;
if (typeof window !== "undefined" && "BroadcastChannel" in window) {
  try {
    adminStatusChannel = new BroadcastChannel("tealpot_admin_status_channel");
  } catch (e) {
    adminStatusChannel = null;
  }
}

export function emitAdminStatusChange(payload) {
  console.log("emitAdminStatusChange", payload);
  socket.emit("adminStatusChanged", payload);
  socket.emit("userStatusChanged", payload);

  const eventPayload = { ...payload, type: "adminStatusChanged", timestamp: Date.now() };
  if (adminStatusChannel) {
    try {
      adminStatusChannel.postMessage(eventPayload);
    } catch (e) {}
  }
  try {
    localStorage.setItem("tealpot_admin_status_event", JSON.stringify(eventPayload));
  } catch (e) {}
}

export function emitAdminDelete(payload) {
  console.log("emitAdminDelete", payload);
  socket.emit("adminDeleted", payload);
  socket.emit("userDeleted", payload);

  const eventPayload = { ...payload, type: "adminDeleted", timestamp: Date.now() };
  if (adminStatusChannel) {
    try {
      adminStatusChannel.postMessage(eventPayload);
    } catch (e) {}
  }
  try {
    localStorage.setItem("tealpot_admin_status_event", JSON.stringify(eventPayload));
  } catch (e) {}
}

export function onAdminStatusEvent(callback) {
  const handleMessage = (e) => {
    if (e?.data) callback(e.data);
  };

  if (adminStatusChannel) {
    adminStatusChannel.addEventListener("message", handleMessage);
  }

  const handleStorage = (e) => {
    if (e.key === "tealpot_admin_status_event" && e.newValue) {
      try {
        const parsed = JSON.parse(e.newValue);
        callback(parsed);
      } catch (err) {}
    }
  };

  window.addEventListener("storage", handleStorage);

  return () => {
    if (adminStatusChannel) {
      adminStatusChannel.removeEventListener("message", handleMessage);
    }
    window.removeEventListener("storage", handleStorage);
  };
}

